import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { ADMIN_EMAILS } from '../../firebase/config';

export default function PrivateRoute({ children, adminOnly = false }) {
  const { currentUser } = useAuth();

 
  if (!currentUser) {
    return <Navigate to="/login" />;
  }

  if (adminOnly && !ADMIN_EMAILS.includes(currentUser.email)) {
    return <Navigate to="/dashboard" />;
  }

  return children;
}